import { view } from '@yola/ws-sdk';
import { BACKGROUND_OPTION_ID } from '../../constants/background-option';
import {
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_POSITION_ATTRIBUTE,
  BACKGROUND_SCALE_ATTRIBUTE,
  BACKGROUND_HIDDEN_ATTRIBUTE,
  BACKGROUND_PLACEHOLDER_ATTRIBUTE,
} from '../../constants/block-background-attributes';
import getBackgroundImageOrigSource from '../get-background-image-orig-source';

const isBackgroundOptionEnabled = (blockNode) =>
  (blockNode.hasAttribute(BACKGROUND_IMAGE_ATTRIBUTE) ||
    blockNode.hasAttribute(BACKGROUND_PLACEHOLDER_ATTRIBUTE)) &&
  !blockNode.hasAttribute(BACKGROUND_HIDDEN_ATTRIBUTE);

const OPTION_RELATED_ATTRIBUTES = [
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_POSITION_ATTRIBUTE,
  BACKGROUND_SCALE_ATTRIBUTE,
];

const createBackgroundOption = ({ blockNode, variationId, backgroundOption }) => {
  const elementId = view.accessors.getLiveElementId(blockNode);

  const values = {};
  const initialValues = {};

  OPTION_RELATED_ATTRIBUTES.forEach((attribute) => {
    const liveValue = blockNode.getAttribute(attribute);

    values[attribute] = liveValue;
    initialValues[attribute] = backgroundOption?.initialValues
      ? backgroundOption.initialValues[attribute]
      : liveValue;
  });

  const origSrc = getBackgroundImageOrigSource(blockNode);

  return {
    id: BACKGROUND_OPTION_ID,
    blockNode,
    elementId,
    variationId,
    values,
    initialValues,
    ...(origSrc && { origSrc }),
    checkVisibility: () => isBackgroundOptionEnabled(blockNode),
  };
};

export default createBackgroundOption;
